// ******************** LAST EDIT - 9/29/20 ************************************

import Search = require("esri/widgets/Search");
import { subclass } from "esri/core/accessorSupport/decorators";
import { tsx, storeNode } from "esri/widgets/support/widget";
// @ts-ignore
import { escapeRegExpString } from "esri/core/string";

const CSS = {
  menuItem: "esri-menu__list-item",
  menuItemFocus: "esri-menu__list-item--focus",
  menuList: "esri-menu__list",
  suggestionList: "esri-search__suggestions-list",
  suggestionMenu: "esri-search__suggestions-menu",
  suggestionListCurrentLocation: "esri-search__suggestions-list--current-location",
  button: "esri-widget--button",
  sourcesButton: "esri-search__sources-button",
  dropdownIcon: "esri-icon-down-arrow esri-search__sources-button--down",
  dropupIcon: "esri-icon-up-arrow esri-search__sources-button--up",
  sourceName: "esri-search__source-name",
  menuHeader: "esri-menu__header"
};

const CSS_INDOORS = {
  items: "i-feature-items",
  item: "i-feature-item",
  itemIcon: "i-feature-item-icon",
  itemText: "i-feature-item-text",
  itemTitle: "i-feature-item-title",
  itemSubTitle: "i-feature-item-subtitle",
  icon: "icon",
  homeIconName: "home-16-f",
  favoriteIconName: "star-16-f",
  locateIconName: "home-16-f", // "esri-icon-locate"
  recentIconName: "pin-16-f"
};

@subclass("app.route.core.Search")
export default class CustomSearch extends Search {

  indoorsContext = null;
  mainSearchbox = null;
  tsUtil = null;
  indoorsDirections = null;
  _prevSearchTerm = null;

  constructor(params?: any) {
    super(params);
    this.mainSearchbox = params.mainSearchbox;
    this.indoorsContext = params.indoorsContext;
    this.tsUtil = params.tsUtil;

    // issue #1694
    const listener = (event) => {
      if (event && event.target && event.target.className === "esri-input esri-search__input") {
      } else {
        if (this.activeMenu === "suggestion") { this.activeMenu = "none"; }
      }
    };

    if (this.indoorsContext.virtualKeyboard.enabled()) {
      this.on("search-focus", event => {
        this.indoorsContext.virtualKeyboard.showSimpleKeyboard({
            handleInputChange : (value) => {
              this.indoorsHandleInputChange(value);
            },
            handleEnterClick : () => {
              this.indoorsHandleEnterClick();
            },
            handleCloseClick : (fromVirtualKeyboard) => {
              this.indoorsHandleCloseClick(fromVirtualKeyboard);
            },
            ignoreElements: this.indoorsIgnoreElement(),
            value : this.searchTerm
        });
      });

      this.on("select-result", () => {
        const context = this.indoorsContext;
        context.virtualKeyboard.closeKeyboard();
      });

      this.on("search-clear", event => {
        this.indoorsContext.virtualKeyboard.clearInput();
      });
    }

    document.body.addEventListener("click", listener);
    let aspectHandle;
    aspectHandle = this.indoorsContext.lib.dojo.aspect.after(this, "destroy", () => {
      document.body.removeEventListener("click", listener);
      if (aspectHandle) { aspectHandle.remove(); }
    });

    this.indoorsInit();
  }

  // @ts-ignore
  protected renderSourceMenuButton() {
    if (!this.mainSearchbox) { return null; }
    // @ts-ignore
    const { messages, activeMenu, sourceMenuId } = this;
    const { activeSourceIndex, allSources } = this.viewModel;

    const sourcesMenuExpanded = activeMenu === "source" ? "true" : "false";

    const activeDescendantId =
      // @ts-ignore
      activeMenu === "source" ? this._buildId("source-item", activeSourceIndex) : null;

    return allSources.length > 1 ? (
      <button
        aria-activedescendant={activeDescendantId}
        key="esri-search__source-menu-button"
        bind={this}
        title={messages.searchIn}
        aria-haspopup="true"
        aria-expanded={sourcesMenuExpanded}
        aria-controls={sourceMenuId}
        class={this.classes(CSS.sourcesButton, CSS.button)}
        // @ts-ignore
        onkeydown={this._handleSourceMenuButtonKeydown}
        // @ts-ignore
        onclick={this._handleSourcesMenuToggleClick}
        // @ts-ignore
        onkeyup={this._handleSourceMenuButtonKeyup}
        // @ts-ignore
        onblur={this._sourcesButtonBlur}
        // @ts-ignore
        afterCreate={storeNode}
        data-node-ref="_sourceMenuButtonNode"
      >
        <span aria-hidden="true" role="presentation" class={CSS.dropdownIcon} />
        <span aria-hidden="true" role="presentation" class={CSS.dropupIcon} />
        <span class={CSS.sourceName}>{
          // @ts-ignore
          this._getSourceName(activeSourceIndex)
        }</span>
      </button>
    ) : null;
  }

  protected renderLocationGroup() {
    // @ts-ignore
    const {locationEnabled, displayedSearchTerm} = this;
    if (!locationEnabled || !!displayedSearchTerm) { return null; }
    if (this.mainSearchbox) { return null; }
    const indoorsPlaces = this.indoorsRenderPlaces();
    if (!indoorsPlaces) { return null; }

    return (
      <ul
        role="presentation"
        key={`esri-search__suggestion-list-current-location`}
        class={this.classes(CSS.menuList, CSS.suggestionList, CSS.suggestionListCurrentLocation)}
      >
      {indoorsPlaces}
      </ul>
    );
  }

  checkSuggestionsMenuVisible(menu) {
    if (menu) {
      const style = getComputedStyle(menu);
      return style.visibility === "visible" && style.height !== "0px";
    }
  }

  protected renderSuggestionsGroup() {
    const context = this.indoorsContext;
    const i18nIndoors = context.i18n;
    let alert = null, menuVisible = false;
    const suggestMenuElems = document.getElementsByClassName(CSS.suggestionMenu);
    if (suggestMenuElems && suggestMenuElems.length > 0) {
      const activeElement = document.activeElement;
      const tagName = activeElement.tagName.toLowerCase();
      const label = i18nIndoors.search.browseSuggestions;
      for (let i = 0; i < suggestMenuElems.length; i++) {
        const menu = suggestMenuElems[i];
        if (this.checkSuggestionsMenuVisible(menu)) {
          alert = (<p class="i-app-alert chrome" role="region" aria-live="polite">{label}</p>);
          menuVisible = true;
          break;
        }
      }

      if (menuVisible && tagName === "input" && document.querySelector("div.i-app-alert").textContent === "") {
        setTimeout(() => {
          document.querySelector("div.i-app-alert").textContent = label;
          setTimeout(() => {
            document.querySelector("div.i-app-alert").textContent = "";
          }, 100);
        }, 500);
      }
    }
    // @ts-ignore
    const suggestionsGroup = this.displayedSearchTerm ? super.renderSuggestionsGroup() : null;
    return (
      <div>
        {suggestionsGroup}
        {alert}
      </div>

    );
  }

  //@ts-ignore
  protected renderSuggestionHeader(suggestResults: __esri.SearchResults<__esri.SuggestResult>) {
    const self: any = this;
    const { allSources, activeSourceIndex } = this.viewModel;
    const { sourceIndex } = suggestResults;
    const source = allSources && allSources.getItemAt(sourceIndex);
    //@ts-ignore
    const layer = source && source.layer;
    const fields = layer && layer.fields;

    const results = suggestResults.results;

    const suggestResultCount = results.length;

    const showMultipleSourceResults = allSources.length > 1 && activeSourceIndex === -1;

    return suggestResultCount && showMultipleSourceResults ? (
      //@ts-ignore
      <div key={`esri-search__suggestion-header-${sourceIndex}`} class={CSS.menuHeader}>
        {self._getSourceName(sourceIndex)}
      </div>
    ) : null;
  }

  //@ts-ignore
  protected renderSuggestList(suggestResults: __esri.SearchResults<__esri.SuggestResult>) {
    const self: any = this;
    const { allSources } = this.viewModel;
    const { sourceIndex } = suggestResults;
    const source = allSources && allSources.getItemAt(sourceIndex);
    //@ts-ignore
    const layer = source && source.layer;
    const fields = layer && layer.fields;

    const results = suggestResults.results;

    const suggestResultCount = results.length;

    self._activeMenuItemIndex = (suggestResultCount && self._prevSearchTerm !== self.viewModel.searchTerm) ?
      -1 : self._activeMenuItemIndex;
    self._prevSearchTerm = self.viewModel.searchTerm;

    return suggestResultCount ? (
      <ul
        key={`esri-search__suggestion-list-${sourceIndex}`}
        class={self.classes(CSS.menuList, CSS.suggestionList)}
      >
        {results.map((suggestion) => this.renderSuggestion(suggestion, self._menuItemCount++))}
      </ul>
    ) : null;
  }

  //@ts-ignore
  protected renderSuggestion(suggestion: __esri.SuggestResult, suggestionIndex: number) {
    const self: any = this;
    const regexContainsHTML = /<[a-z/][\s\S]*>/i;
    const { _activeMenuItemIndex, messages } = self;
    const { searchTerm } = this.viewModel;
    if (searchTerm) {
      const { text } = suggestion;
      const resultText = text || messages.untitledResult;
      const containsHTML = regexContainsHTML.test(resultText);
      //@ts-ignore
      const matches: VNode[] = [];
      if (containsHTML) {
        matches.push(<div innerHTML={resultText} />);
      } else {
        const resultParts = self._splitResult(resultText, searchTerm);
        const searchTermLC = searchTerm.toLowerCase();
        resultParts.forEach((part, partIndex) => {
          if (part && part.length) {
            if (part.toLowerCase() === searchTermLC) {
              matches.push(<strong key={partIndex}>{part}</strong>);
            } else {
              matches.push(part);
            }
          }
        });
      }

      const focused = _activeMenuItemIndex === suggestionIndex;
      const id = self._buildId("suggestion-item", suggestionIndex);

      return (
        <li
          bind={this}
          id={id}
          aria-selected={(
            this.activeMenu === "suggestion" && self._activeMenuItemIndex === suggestionIndex
          ).toString()}
          onclick={self._handleSuggestionClick}
          key={`esri-search__suggestion_${suggestionIndex}`}
          data-suggestion={suggestion}
          role="menuitem"
          tabindex="-1"
          class={this.classes(CSS.menuItem, focused ? CSS.menuItemFocus : null)}
        >
          {matches}
        </li>
      );
    }

    return undefined;
  }

  _splitResult(input: string, needle: string): string[] {
    const escapedNeedle = escapeRegExpString(needle);
    const matches = input.replace(new RegExp(`(^|)(${escapedNeedle})(|$)`, "ig"), "$1|$2|$3");
    return matches.split("|");
  }

  /* Indoors *************************************************************** */

  indoorsInit() {
    const lib = this.indoorsContext.lib;
    const properties = this.mainSearchbox ? { tsUtil: this.tsUtil } : { directions: true, tsUtil: this.tsUtil };
    this.viewModel = new lib.indoors.CustomSearchViewModel(properties);
  }

  indoorsRenderIcon(iconName) {
    const iconPath = "libs/calcite-ui-icons/icons/sprite-16.svg#" + iconName;
    return <svg class={CSS_INDOORS.itemIcon}><use href={iconPath}></use></svg>;
  }

  indoorsRenderPlace(item, key, iconName, title, subTitle) {
    const self: any = this;

    const clicked = () => {
      self._focus("none");
      if (this.indoorsDirections &&
          typeof this.indoorsDirections.indoorsMyPlaceSelected === "function") {
        this.indoorsDirections.indoorsMyPlaceSelected(item);
      }
    };

    const liMouseDown = (event) => {
      if (event && event.target && event.target.tagName === "LI") {
        self._focus("none");
        if (this.indoorsDirections &&
            typeof this.indoorsDirections.indoorsMyPlaceSelected === "function") {
          this.indoorsDirections.indoorsMyPlaceSelected(item);
        }
      }
    };

    const onKeyDown = (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        clicked();
      }
    };

    const icon = this.indoorsRenderIcon(iconName);
    const node = (
      <li key={key} onmousedown={liMouseDown}
        onkeydown={onKeyDown}
        class={CSS_INDOORS.item} bind={this}
        onclick={clicked}
        onkeyup={self._handleSuggestionKeyup}
        role="menuitem"
        tabindex="0">
        {icon}
        <span class={CSS_INDOORS.itemText}>
          <span key="t" class={CSS_INDOORS.itemTitle}>{title}</span>
          <span key="st" class={CSS_INDOORS.itemSubTitle}>{subTitle}</span>
        </span>
      </li>
    );
    return node;
  }

  indoorsRenderPlaces() {
    let iconName, item, key, list, place, subTitle, title;
    // @ts-ignore
    const messages = this.messages;
    const places = [];
    const context = this.indoorsContext;
    const i18nIndoors = context.i18n;
    const isKiosk = context.uiMode.isKiosk;
    const referenceLayer = context.session.referenceLayer;

    if (context.bluedot && context.bluedot.hasLocation()) {
      iconName = CSS_INDOORS.locateIconName;
      title = messages.useCurrentLocation;
      subTitle = null;
      item = {
        isBluedot: true,
        key: "i-place-bluedot",
        label: messages.useCurrentLocation
      };
      place = this.indoorsRenderPlace(item, item.key, iconName, item.label, null);
      if (place) { places.push(place); }
    }

    if (places.length === 0 && !referenceLayer.hasItems()) { return null; }

    item = referenceLayer.homeLocation;
    if (item.isValid()) {
      key = "i-place-home";
      iconName = CSS_INDOORS.homeIconName;
      title = i18nIndoors.yourPlaces.home;
      subTitle = item.getTitle();
      place = this.indoorsRenderPlace(item, key, iconName, title, subTitle);
      if (place) { places.push(place); }
    }

    iconName = CSS_INDOORS.favoriteIconName;
    list = referenceLayer.favorites;
    if (list && list.length > 0) {
      list.forEach((item, index) => {
        const sk = item.sourceKey || "sk";
        key = "i-place-favorite-" + index + "-" + sk + "-" + item.uniqueId;
        title = item.getTitle();
        subTitle = item.getSubTitle();
        place = this.indoorsRenderPlace(item, key, iconName, title, subTitle);
        if (place) { places.push(place); }
      });
    }

    iconName = CSS_INDOORS.recentIconName;
    list = referenceLayer.recent;
    if (!isKiosk && list && list.length > 0) {
      list.forEach((item, index) => {
        const sk = item.sourceKey || "sk";
        key = "i-place-recent-" + index + "-" + sk + "-" + item.uniqueId;
        title = item.getTitle();
        subTitle = item.getSubTitle();
        place = this.indoorsRenderPlace(item, key, iconName, title, subTitle);
        if (place) { places.push(place); }
      });
    }

    if (places.length > 0) { return places; }
    return null;
  }

  indoorsHandleInputChange = (input) => {
    if (this.viewModel.searchTerm !== input) {
      this.viewModel.searchTerm = input;
    }
    if (!this.viewModel.searchTerm) {
      return;
    }
    this.suggest();
  }

  indoorsHandleEnterClick = () => {
    if (!this.viewModel.searchTerm) {
      return;
    }
    const self: any = this;
    const list = self._suggestionListNode.getElementsByTagName("li");
    if (self._activeMenuItemIndex) {
      if (self._activeMenuItemIndex === -1) { self.search(); }
      else {
        const item = list[self._activeMenuItemIndex];
        const suggestResult = item["data-suggestion"];
        if (suggestResult) {
          self._focus();
          self.search(suggestResult);
        }
      }
    } else { self.search(); }
  }

  indoorsHandleCloseClick = (fromVirtualKeyboard) => {
    // @ts-ignore
    if (fromVirtualKeyboard) { this.blur(); }
  }

  indoorsIgnoreElement = () => {
      const nodeList = [];
      const nodeSearchCollection = document.getElementsByClassName("esri-input esri-search__input");
      // @ts-ignore
      const nodeArray = Array.from(nodeSearchCollection);
      nodeArray.forEach(ele => {
          nodeList.push(ele);
      });
      return nodeList;
  }

  isPeopleLayer(fields) {
    if (fields) {
      let count = 0;
      const matched = fields.some((field) => {
        const lc = field.name.toLowerCase();
        if (lc === "knownas" || lc === "email") {
          count++;
          if (count >= 2) { return true; }
        }
        return false;
      });
      return matched;
    }
    return false;
  }

  getAttributeValue(attributes, name) {
    if (!attributes || !name) { return; }
    if (typeof name !== "string") { return; }
    if (attributes.hasOwnProperty(name)) { return attributes[name]; }
    let value, lc = name.toLowerCase();
    Object.keys(attributes).some(key => {
      if (key.toLowerCase() === lc) {
        value = attributes[key];
        return true;
      }
      return false;
    });
    return value;
  }

}
